// Media Gallery export: GrainedWoodFinishesGalleryCTA


// ✅ ONCE-ONLY LINES (copy once per file/snippet — skip if you already have these):
window.MEDIA_GALLERY_SETS = window.MEDIA_GALLERY_SETS || {};


// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["GrainedWoodFinishesGalleryCTA"] = [
  {
    "heading": "<h1><br/><br/>Grained Wood Demos</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "videos": [
      {
        "type": "vimeo",
        "title": "Five Oak Finishes",
        "alt": "Five Oak Finishes",
        "url": "https://vimeo.com/1164866660",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b2b12816-32c0-4f40-aefa-8086d88f8914.gif?ClientID=sulu&Date=1771028306&Signature=a8c7696a9aba849a695d3ee45f7b756be7a3a412",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "Pickled Oak",
        "alt": "Pickled Oak",
        "url": "https://vimeo.com/1055284014",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/80f23421-97a2-4a9e-a28e-ec36d91cd292.gif?ClientID=sulu&Date=1770888585&Signature=12eef8b1f97280fe5fe575fd9d4ca8f86f8d29af",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Pickled Oak Kits",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "Barn Wood",
        "alt": "Barn Wood",
        "url": "https://vimeo.com/1055317823",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/0bdaad2b-2fd3-4b69-b058-ea51c9f08599.gif?ClientID=sulu&Date=1770888622&Signature=c2d320eda57b1708919b0a6339a7b7d33fd5a4dd",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_barn-wood_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "White Oak / Sun Bleached",
        "alt": "White Oak / Sun Bleached",
        "url": "https://vimeo.com/1094873442",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e904372e-9513-4227-a7c2-56c600f9c4b0.gif?ClientID=sulu&Date=1770890074&Signature=e904e16aa46264dc8c9bb948b464a125d65f590a",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "French Oak",
        "alt": "French Oak",
        "url": "https://vimeo.com/1055319435",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fa83117a-8fb1-486d-a8b1-f15b0854296e.gif?ClientID=sulu&Date=1770888691&Signature=d8ba6eaaf656c7e97e260b1e67e9f6f9cca54568",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_french-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "Dark Oak, Weathered Wood & White Wash",
        "alt": "Dark Oak, Weathered Wood & White Wash",
        "url": "https://vimeo.com/1055324192",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/1f5f3744-2ffb-4214-aea8-34d1b753b988.gif?ClientID=sulu&Date=1770888660&Signature=f703b516da6f5b5361267a432a3f2c4ed689bcce",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_dark-oak_",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "Black Walnut",
        "alt": "Black Walnut",
        "url": "https://vimeo.com/1055321744",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/693bfcf9-b2a2-48a6-bde1-201cdc9f7cfa.gif?ClientID=sulu&Date=1770888760&Signature=b16708dd087cb70822184f6588af94dd904817c8",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": "https://retique.com/products/woodnfinish_black-walnut_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "vimeo",
        "title": "Harbor Gray",
        "alt": "Harbor Gray",
        "url": "https://vimeo.com/1095056708",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f6f8fa17-c2f1-4a5d-9d24-3b3b4bd3ccfe.gif?ClientID=sulu&Date=1770889536&Signature=d9e7c9feba5fab42d26906d6a60b988266a8fa64",
        "thumb_w": 0,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ OPTIONAL: paste these ONCE after adding/updating one or more sets (helps previews refresh):
document.dispatchEvent(new CustomEvent("media_gallery_sets_ready"));
document.dispatchEvent(new CustomEvent("vimeo_sets_ready"));

